let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dFwxF")).then(() => parcelRequire('6JNBC'));